module.exports = __webpack_public_path__ + "static/70-seat-coach-hire-interior-e4bbac2834076aa7207b6ea710ad0a24.jpg";